export const formatNumber = (number = 0) => {
    return parseInt(number).toLocaleString('en-US')
}